const generateQueryParamsUrl = (endpoint, filters) =>
  Object.keys(filters)
    .reduce(
      (url, key) =>
        filters[key] !== '' && filters[key] !== 'ALL' ? url.concat(`&${key}=${filters[key]}`) : url,
      endpoint,
    )
    .replace('/&', '/?');

export default generateQueryParamsUrl;
